import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { buildWaitlistConfirmationHtml } from '../../convex/emailContent';
import { WAITLIST } from '../../convex/waitlistCopy';
import s from './waitlist-email-preview.module.scss';

const APP_URL = 'https://app.usefragments.com';
const SUBJECT = "You're on the Fragments Cloud waitlist";
const PREVIEW_TEXT =
  "You're on the Fragments Cloud waitlist. We'll be in touch as onboarding opens.";

export const Route = createFileRoute('/waitlist-email-preview')({
  component: WaitlistEmailPreviewPage,
});

function WaitlistEmailPreviewPage() {
  const isPreviewEnabled =
    import.meta.env.DEV || import.meta.env.VITE_DEV_TOOLS === 'true';

  const emailHtml = React.useMemo(
    () =>
      buildWaitlistConfirmationHtml({
        name: 'Alex',
        appUrl: APP_URL,
        founderLimit: WAITLIST.founderLimit,
        productDescription: WAITLIST.productDescription,
        surveyUrl: `${APP_URL}/survey?t=preview-token`,
      }),
    [],
  );

  if (!isPreviewEnabled) {
    return (
      <div className={s.page}>
        <div className={s.emptyState}>
          <h1 className={s.title}>Email preview unavailable</h1>
          <p className={s.copy}>
            This route is only enabled in development so the finalized template
            can be reviewed safely before launch.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={s.page}>
      <div className={s.header}>
        <p className={s.kicker}>Waitlist confirmation email</p>
        <h1 className={s.title}>Final dark-mode template preview</h1>
        <p className={s.copy}>
          This route renders the exact email HTML used for new waitlist signups,
          with desktop and mobile canvases side by side.
        </p>
      </div>

      <div className={s.metaGrid}>
        <div className={s.metaCard}>
          <span className={s.metaLabel}>Subject</span>
          <span className={s.metaValue}>{SUBJECT}</span>
        </div>
        <div className={s.metaCard}>
          <span className={s.metaLabel}>Preview text</span>
          <span className={s.metaValue}>{PREVIEW_TEXT}</span>
        </div>
      </div>

      <div className={s.previewGrid}>
        <section className={s.previewCard}>
          <div className={s.previewHeader}>
            <span className={s.previewLabel}>Desktop canvas</span>
            <span className={s.previewSize}>600px email width</span>
          </div>
          <div className={s.previewFrame}>
            <iframe
              srcDoc={emailHtml}
              title="Waitlist email desktop preview"
              className={s.iframe}
            />
          </div>
        </section>

        <section className={`${s.previewCard} ${s.mobileCard}`}>
          <div className={s.previewHeader}>
            <span className={s.previewLabel}>Mobile canvas</span>
            <span className={s.previewSize}>390px viewport</span>
          </div>
          <div className={`${s.previewFrame} ${s.mobileFrame}`}>
            <iframe
              srcDoc={emailHtml}
              title="Waitlist email mobile preview"
              className={s.iframe}
            />
          </div>
        </section>
      </div>
    </div>
  );
}
